import { css, Global } from '@emotion/react';
import React from 'react';

// TODO: Remove this once we have a better way to handle marmalade fonts

export const GlobalStyles = () => (
    <Global
        styles={css`
            * {
                box-sizing: border-box;
            }

            html,
            body,
            #root {
                height: 100%;
            }

            [class^='FormControl_validationAdornment']:empty,
            [class^='FormControl_suffix']:empty {
                padding: 0;
            }
            [class^='.FormControl_prefix'] {
                height: auto;
            }
        `}
    />
);
